var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightThunderstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "154px",
    viewBox: "0 0 135 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "night - thunderstorm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.4644699%",
    y1: "72.8710355%",
    x2: "63.7305027%",
    y2: "39.9796208%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.5161778%",
    y1: "64.8727273%",
    x2: "8.62380839%",
    y2: "22.6545455%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "night---thunderstorm",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.998732,46.8518157 C99.5211827,46.0036575 89.9953571,40.439649 84.1041444,31.7268584 C78.2129317,23.0140678 76.5938107,12.0952922 79.7027967,2.04573639 C79.8627025,1.46849966 79.6637666,0.851413826 79.1969238,0.476552963 C78.730081,0.1016921 78.0850295,0.0410810982 77.5566267,0.322425652 C64.831216,7.5427523 58.0098378,21.9853391 60.5123312,36.40952 C63.0148247,50.8337009 74.3016468,62.1295923 88.7142469,64.6340965 C103.126847,67.1386007 117.557838,60.3117415 124.772368,47.5761057 C125.104961,47.0435757 125.070491,46.3599833 124.686017,45.8636698 C124.301544,45.3673564 123.648633,45.1636142 123.050441,45.3532846 C118.834836,46.6796602 114.404949,47.1882773 109.998732,46.8518157 L109.998732,46.8518157 Z",
    id: "Path",
    fill: "#EFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7846986,34.1468394 C59.965981,34.1417853 74.8214334,43.0587579 82.3800995,57.3136981 C94.8680469,50.03943 110.593908,51.3518532 121.693246,60.5946305 C132.792585,69.8374079 136.879845,85.0240096 131.911005,98.5596814 C126.942165,112.095353 113.985167,121.070903 99.5197508,120.997697 L43.6599558,121.146839 C19.5472281,121.146839 0,101.671227 0,77.6468394 C0,53.6224545 19.5472281,34.1468394 43.6599558,34.1468394 L43.7846986,34.1468394 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-2)",
    transform: "translate(99.782296, 87.183986) rotate(-74.390000) translate(-99.782296, -87.183986) ",
    cx: 99.7822963,
    cy: 87.1839858,
    rx: 34.1705349,
    ry: 34.2478481
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EFCC00",
    points: "67.3902041 100.146839 62 130.62806 72.7804082 130.62806 67.3902041 153.146839 93 121.346839 80.8783673 121.346839 91.6587755 100.146839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,141.846839 C57,146.983088 52.7467051,151.146839 47.5,151.146839 C42.2532949,151.146839 38,146.983088 38,141.846839 C38,133.696839 45.6612903,126.146839 47.5,126.146839 C49.3387097,126.146839 57,133.646839 57,141.846839 Z",
    id: "Path",
    fill: "#0BAEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightThunderstorm);
export default __webpack_public_path__ + "static/media/night-thunderstorm.2d2eeb22f74ca740d10908c97ba1ce01.svg";
export { ForwardRef as ReactComponent };